import { useEffect, useState } from 'react';
import { formatOffset } from '@avslack/shared';

/**
 * Mennyi ideje tart az oleles.
 *
 * ─── Miert a kezdes idejebol szamolunk, es nem leptetunk? ───────────────────
 *
 * Kezenfekvo lenne masodpercenkent hozzaadni egyet egy szamlalohoz. Csak epp
 * az idozitot nem mi iranyitjuk: a hatterbe kerult lapon a bongeszo ritkitja,
 * alvo gepen megallitja. Egy leptetett szamlalo ilyenkor lemarad, es a hivas
 * vegen mar percekkel kevesebbet mutatna - csendben, eszrevetlenul.
 *
 * A kezdes idopontjabol szamolva ez nem tortenhet meg: az ora minden ebredes
 * utan azonnal a helyes erteken all. Az `interval` igy nem a MERES, csak a
 * frissites - ha kesik, legfeljebb kesobb rajzolunk, de sosem rosszat.
 *
 * ─── A szerver ideje, nem a miénk ───────────────────────────────────────────
 *
 * A `startedAt` a szervertol jon. Ha a gep oraja elore jar, a kulonbseg
 * negativ lehet - a `formatOffset` ezt nullara vagja, tehat rosszabb esetben
 * is `0:00`-rol indul, nem valami ertelmetlen erteket mutat.
 */
export function HuddleTimer({
  startedAt,
  className,
}: {
  /** A huddle kezdete, ISO idobelyeg a szervertol. */
  startedAt: string;
  className?: string;
}) {
  const kezdet = new Date(startedAt).getTime();
  const [most, setMost] = useState(() => Date.now());

  useEffect(() => {
    const timer = setInterval(() => setMost(Date.now()), 1000);
    return () => clearInterval(timer);
  }, []);

  // Ervenytelen idobelyeg eseten inkabb nem mutatunk semmit, mint "NaN:NaN"-t.
  if (Number.isNaN(kezdet)) return null;

  const eltelt = formatOffset(most - kezdet);

  return (
    <time
      title="Az ölelés hossza"
      // A szamok NE ugraljanak masodpercenkent: fix szelessegu szamjegyek.
      className={['tabular-nums', className].filter(Boolean).join(' ')}
    >
      {eltelt}
    </time>
  );
}
